import React from 'react';
import { Navigate } from 'react-router-dom';

// Groups allowed to see the Family Coupons UI (route + entry buttons).
export const COUPON_ALLOWED_GROUPS = [
  'Coordinator',
  'OnsiteCoordinator',
  'CoordinatorNorthStar',
  'Finance',
  'FinancialAdmin',
  'Admin',
  'Administrator',
  'OperationsManager',
];

// Reads localStorage "groups" (JSON array stored at login) and checks
// membership case-insensitively against allowedGroups.
// NOTE: the backend 403 is the real security; this check is UI convenience only.
// If allowedGroups is not provided, or groups are missing/unreadable in
// localStorage, we do NOT hide anything — let the backend decide.
export function hasAllowedGroup(allowedGroups) {
  if (!Array.isArray(allowedGroups) || allowedGroups.length === 0) return true;

  let groups = [];
  try {
    const raw = localStorage.getItem('groups');
    const parsed = raw ? JSON.parse(raw) : null;
    if (Array.isArray(parsed)) {
      groups = parsed.filter((g) => typeof g === 'string' && g.trim() !== '');
    }
  } catch (err) {
    groups = [];
  }

  if (groups.length === 0) return true;

  const allowed = new Set(allowedGroups.map((g) => String(g).toLowerCase()));
  return groups.some((g) => allowed.has(g.toLowerCase()));
}

const ProtectedRoute = ({ element, isAuthenticated, allowedGroups }) => {
  if (!isAuthenticated) return <Navigate to="/login" />;
  // Optional group gate — only active when allowedGroups is passed in.
  // Backend 403 is the real security; this is UI convenience only.
  if (!hasAllowedGroup(allowedGroups)) return <Navigate to="/login" />;
  return element;
};

export default ProtectedRoute;
